export enum EQueryTab {
    awaiting = 'awaiting',
    submitted = 'submitted'
}
